import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { Stack } from '@fiverr-private/layout_components';
import Pagination from '../common/pagination/Pagination';
import { AppContext } from '../../context/listingsContext';
import { DynamicGigListings } from '../../common';
import { ListingsImpressionContainer } from '../../../../../shared/context/ListingsImpressionContainer/ListingsImpressionContainer';
import { useFetchUserData } from '../banner/util';
import { AIConsultationBanner } from '../banner/AIConsultationBanner';
import { shouldShowAIConsultationBanner } from '../banner/AIConsultationBanner/utils';
import { useBusinessListingsContext } from '../BusinessPageLayout';
import ProjectManageBanner from '../banner/ProjectManageBanner';
import styles from './index.module.scss';

const BusinessGigsGridListing = () => {
    const {
        listings: [listings],
        pagination,
    } = useContext(AppContext);

    const { isMobile } = getContext();
    const { resultsCount, categoryIds, activeFilters, displayQuery } = useBusinessListingsContext();
    const userData = useFetchUserData();
    const { gigs } = listings;
    const noGigs = isEmpty(gigs);
    const showPagination = !noGigs && typeof window !== 'undefined' && !!window?.location;

    if (noGigs) {
        return null;
    }
    const showAIConsultationBanner = shouldShowAIConsultationBanner({
        resultsCount,
        categoryIds,
        isExpertListings: true,
        filters: activeFilters,
        searchTerm: displayQuery,
    });

    const renderBanner = () => {
        const { number_of_results, filters } = listings?.impressionEnrichment?.listings || {};
        const minGigsToShowBanner = 9;
        const rowPosition = 4;

        if (number_of_results <= minGigsToShowBanner) {
            return null;
        }
        return (
            <ProjectManageBanner
                resultsCount={number_of_results}
                hasActiveFilters={!isEmpty(filters)}
                position={rowPosition}
                isFullCatalog={true}
            />
        );
    };

    return (
        <div className={isMobile && 'm-t-16'}>
            <ListingsImpressionContainer>
                {showAIConsultationBanner && (
                    <Stack direction="column" width="100%" marginBottom={10}>
                        <AIConsultationBanner
                            resultsCount={resultsCount}
                            hasActiveFilters={!isEmpty(activeFilters)}
                            position={0}
                            userData={userData}
                        />
                    </Stack>
                )}
                <DynamicGigListings
                    banners={renderBanner()}
                    gigCardListingsClassName={styles.gigListingsContainer}
                    listings={{ ...listings, gigs }}
                />
            </ListingsImpressionContainer>
            {showPagination && <Pagination pagination={pagination} />}
        </div>
    );
};

export default BusinessGigsGridListing;
